import o from "./index135.js";
/* empty css         */
import r from "./index130.js";
const e = /* @__PURE__ */ r(o, [["__scopeId", "data-v-0f9cb8b6"]]);
export {
  e as default
};
